import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	windowWidth:0,//页面宽度
	windowHeight:0,//页面高度
	language: 'cn',//语言
	
	//切页高度，用于切页高度记录
	h_home:0,
	h_about:0,
	h_productCenter:0,
	h_productDetails:0,
	h_customer:0,
	h_news:0,
	h_contact:0,
  },
  mutations: {
	WINDOW_WIDTH(state,{ windowWidth, windowHeight }){
		state.windowWidth=windowWidth
	},
	WINDOW_HEIGHT(state,{ windowWidth, windowHeight }){
		state.windowHeight=windowHeight
	},
	LANGUAGE(state,{ language }){
		state.language = language
		sessionStorage.setItem("LANGUAGE", JSON.stringify(language))
	},
	CUTTING_HEIGHT(state,{type,height}){
		if(type=='/'){state.h_home = height}
		if(type=='/aboutUs'){state.h_about = height}
		if(type=='/productCenter'){state.h_productCenter = height}
		if(type=='/productDetails'){state.h_productDetails = height}
		if(type=='/customer'){state.h_customer = height}
		if(type=='/news'){state.h_news = height}
		if(type=='/contactUs'){state.h_contact= height}
	}
  },
  actions: {
	setWindowWidthHeight({ commit },data){
		commit('WINDOW_WIDTH',{windowWidth:data.windowWidth})
		commit('WINDOW_HEIGHT',{windowHeight:data.windowHeight})
	},
	setLanguage({ commit },data){
		commit('LANGUAGE',{language:data.language})
	},
	setCuttingHeight({ commit },data){
		commit('CUTTING_HEIGHT',{type:data.type,height:data.height})
	}
  },
  modules: {
	
  }
})
